import React,{useRef} from 'react';
import { Component } from 'react';
import ReactDOM from 'react-dom';

import Header from "../components/header_login";
import Form from "../components/login/form";

export default class Login extends Component {
    constructor(props){
        super(props)

        this.state = {
            name: 'login',
            banners: [],
            error: null,
            formLogin:{
                user:'',
                password:'',
                token:'',
            },
        }

        this.formLoginSubmit = this.formLoginSubmit.bind(this)
        this.handleChangeFormLogin = this.handleChangeFormLogin.bind(this)
    }

    handleChangeFormLogin(e){
        this.setState({
            formLogin:{
                ...this.state.formLogin,
                [e.target.name]:e.target.value
            }
        })
    }

    formLoginSubmit = async (e) => {
        e.preventDefault()
        if(
            this.state.formLogin.user == '' ||
            this.state.formLogin.password == ''
        ){
            swal({
                text: "Debes digitar todos los datos",
                icon: "warning",
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: "",
            button: false,
            closeOnClickOutside: false,
        });

        try{
            let configLogin = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formLogin)
            }
            let resLogin = await fetch(`${https}api/login`,configLogin)
            let dataLogin = await resLogin.json()
            if(dataLogin == 1){
                this.setState({
                    formLogin:{
                        user:'',
                        password:'',
                        token:'',
                    }
                })
                location.reload();
            }else if(dataLogin == 2) {
                swal({
                    text: "Usuario o contraseña incorrecta",
                    icon: "warning",
                    button: "OK!",
                });
            }else{
                alert('ocurrio un error');
                setTimeout(function (){
                    location.reload();
                },1000)
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    render() {
        return (
            <div>
                <Header
                />
                <Form
                    formlogin={this.state.formLogin}
                    onChangeLogin={this.handleChangeFormLogin}
                    onSubmitLogin={this.formLoginSubmit}
                />
            </div>
        );
    }

}

if (document.getElementById('content_login')) {
    ReactDOM.render(<Login />, document.getElementById('content_login'))
}
